import {useLayoutEffect, useState} from 'react'

const useBreakpoint = (breakpoint) => {
  const [match, setMatch] = useState(true)
  useLayoutEffect(() => {
    const query = `(min-width: ${breakpoint}px)`
    const mql = window.matchMedia(query)
    setMatch(mql.matches)
    const updateMatch = () => setMatch(mql.matches)
    if (!mql.addEventListener) {
      // fallback for safari https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList#Browser_compatibility
      mql.addListener(updateMatch)
      return () => {
        mql.removeListener(updateMatch)
      }
    } else {
      mql.addEventListener('change', updateMatch)
      return () => {
        mql.removeEventListener('change', updateMatch)
      }
    }
  }, [breakpoint])

  return match
}

export default useBreakpoint
